module.exports = "//static.hsappstatic.net/LoginUI/static-1.8493/img/google-logo.png"